import { render, staticRenderFns } from "./HeroAdd.vue?vue&type=template&id=4051a235&scoped=true&"
import script from "./HeroAdd.vue?vue&type=script&lang=js&"
export * from "./HeroAdd.vue?vue&type=script&lang=js&"
import style0 from "./HeroAdd.vue?vue&type=style&index=0&id=4051a235&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4051a235",
  null
  
)

export default component.exports